import { useMemo } from "react";

import type { PaginatedResponse } from "../types";

type Mutations<T, U> = Partial<Record<keyof U, (item: T) => any>>;

export const useModifyDataForTable = <T, U>(
  data: PaginatedResponse<T> | undefined,
  mutations: Mutations<T, U> = {},
  { spread }: { spread?: boolean } = { spread: true },
): U[] => {
  return useMemo(() => {
    if (!data) return [];

    return data.data.map((item) => {
      const transformedItem: Partial<U> = {} as Partial<U>;

      for (const key in mutations) {
        if (Object.prototype.hasOwnProperty.call(mutations, key)) {
          transformedItem[key as keyof U] = mutations[key]?.(item);
        }
      }

      return spread ? { ...item, ...transformedItem } : transformedItem;
    }) as U[];
  }, [data, mutations, spread]);
};
